<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>审批</el-breadcrumb-item>
      <el-breadcrumb-item>报销</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.bxtype" placeholder="请选择" style="width: 100%">
              <el-option label="请选择报销类型" value="0"></el-option>
              <el-option label="差旅费" value="1"></el-option>
              <el-option label="办公费" value="2"></el-option>
              <el-option label="招待费" value="3"></el-option>
              <el-option label="其他" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="ShangJigouName" label="公司名称" min-width="10%"></el-table-column>
          <el-table-column prop="CurJigouName" label="申请部门" min-width="11%"></el-table-column>
          <el-table-column prop="Bxtype" label="报销类型" min-width="5%"></el-table-column>
          <el-table-column prop="Bxliyou" label="申请事由" min-width="18%"></el-table-column>
          <el-table-column prop="Bxmoney" label="报销金额" min-width="5%"></el-table-column>
          <el-table-column prop="Createtime" label="发生日期" min-width="8%"></el-table-column>
          <el-table-column prop="Bxbeizhu" label="备注" min-width="20%"></el-table-column>
          <el-table-column label="报销凭证" min-width="6%">
            <template v-slot="scope">
              <el-button v-for="Bxpzurl in scope.row.Bxpzurls" type="text" @click="clickfile(Bxpzurl)">点击查看</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="Name1" label="经办人" min-width="4%"></el-table-column>
          <el-table-column prop="Bxpaystatusname" label="支付状态" min-width="5%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Bxpaystatus == 0" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
              <el-button v-if="SubRule_ShenPiBaoXiao_CaiWu && scope.row.Bxpaystatus == 1" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickzhifu(scope.row,0)">未支付</el-button>
              <el-button v-if="SubRule_ShenPiBaoXiao_CaiWu && scope.row.Bxpaystatus == 0" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickzhifu(scope.row,1)">已支付</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <el-dialog
          title="审批"
          :visible.sync="dialogVisible"
          width="20%">
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="ShenHeOK">同意</el-button>
            <el-button type="danger" @click="ShenHeNO">拒绝</el-button>
          </span>
        </el-dialog>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加报销" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <div class="warntitle">先将纸质付款申请单全部审核完毕，然后再拍照上传睿云。</div>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">报销类型(必选)</span>
          </label>
          <el-select v-model="addForm.bxtype" placeholder="请选择" style="width: 100%">
            <el-option label="请选择" value="0"></el-option>
            <el-option label="差旅费" value="1"></el-option>
            <el-option label="办公费" value="2"></el-option>
            <el-option label="招待费" value="3"></el-option>
            <el-option label="其他" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">申请事由(必填)</span>
          </label>
          <el-input v-model="addForm.bxliyou"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">报销金额(必填)</span>
          </label>
          <el-input v-model="addForm.bxmoney"></el-input>
        </el-form-item>
        <el-form-item label="备注" class="addAdminForm">
          <el-input v-model="addForm.bxbeizhu"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">报销凭证(必填)</span>
          </label>
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

  </el-tabs>
  </div>
</template>

<script>
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RsljigouInternal,
    TencentyunCosUploadMultiImgOrPdf
  },
  name: 'MyShenPiBaoXiao',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [],
      addForm: {
        bxtype: '0',
        bxliyou: '',
        bxmoney: '',
        bxbeizhu: '',
        bxpzurl: ''
      },
      timer: '',
      // 查询
      keywords: {
        jigouid: '-1',
        jigouname: '',
        bxtype: '0'
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogVisible: false,
      apiShenPiBaoXiaoSHUrl: '',
      bxid: 0,
      SubRule_ShenPiBaoXiao_BuMen: false,
      SubRule_ShenPiBaoXiao_CaiWu: false,
      SubRule_ShenPiBaoXiao_DanWei: false,
      SubRule_ShenPiBaoXiao_DanWeiZong: false
    }
  },
  mounted () {
    this.apiGetShenPiBaoXiaoNum()
    this.apiGetShenPiBaoXiaoList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiBaoXiao_BuMen', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiBaoXiao_BuMen = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiBaoXiao_CaiWu', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiBaoXiao_CaiWu = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiBaoXiao_DanWei', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiBaoXiao_DanWei = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiBaoXiao_DanWeiZong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiBaoXiao_DanWeiZong = true
      }
    })
  },
  methods: {
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.addForm.bxpzurl = url
    },
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickfile (url) {
      Vue.prototype.FunReviewFileurl(url, this.$router)
    },
    clickadd () {
      this.apiAddShenPiBaoXiao()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    ShenHe1 (row) {
      this.dialogVisible = true
      this.apiShenPiBaoXiaoSHUrl = Vue.prototype.global.Url_ShenPiBaoXiaoSH1
      this.bxid = row.Id
    },
    ShenHe2 (row) {
      this.dialogVisible = true
      this.apiShenPiBaoXiaoSHUrl = Vue.prototype.global.Url_ShenPiBaoXiaoSH2
      this.bxid = row.Id
    },
    ShenHe3 (row) {
      this.dialogVisible = true
      this.apiShenPiBaoXiaoSHUrl = Vue.prototype.global.Url_ShenPiBaoXiaoSH3
      this.bxid = row.Id
    },
    ShenHe4 (row) {
      this.dialogVisible = true
      this.apiShenPiBaoXiaoSHUrl = Vue.prototype.global.Url_ShenPiBaoXiaoSH4
      this.bxid = row.Id
    },
    ShenHeOK () {
      this.dialogVisible = false
      this.apiShenPiBaoXiaoSH(1)
    },
    ShenHeNO () {
      this.dialogVisible = false
      this.apiShenPiBaoXiaoSH(-1)
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelShenPiBaoXiao(row.Id)
      })
    },
    clickzhifu (row, bxpaystatus) {
      this.apiChangeBaoXiaoPayStatus(row.Id, bxpaystatus)
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetShenPiBaoXiaoNum()
      this.apiGetShenPiBaoXiaoList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetShenPiBaoXiaoList()
    },
    apiGetShenPiBaoXiaoNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.keywords.jigouid,
        bxtype: that.keywords.bxtype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiBaoXiaoNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetShenPiBaoXiaoList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid,
        bxtype: that.keywords.bxtype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiBaoXiaoList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            for (var i = 0; i < that.dataList.length; i++) {
              that.dataList[i].Bxpzurls = that.dataList[i].Bxpzurl.split('@@@')
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddShenPiBaoXiao: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bxtype: that.addForm.bxtype,
        bxliyou: that.addForm.bxliyou,
        bxmoney: that.addForm.bxmoney,
        bxbeizhu: that.addForm.bxbeizhu,
        bxpzurl: that.addForm.bxpzurl
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddShenPiBaoXiao, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiBaoXiaoNum()
            that.apiGetShenPiBaoXiaoList()

            // 清空添加
            that.addForm.bxtype = '0'
            that.addForm.bxliyou = ''
            that.addForm.bxmoney = ''
            that.addForm.bxbeizhu = ''
            that.addForm.bxpzurl = ''
            that.$refs.MultiImgOrPdf.cleardata()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelShenPiBaoXiao: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bxid: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelShenPiBaoXiao, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiBaoXiaoNum()
            that.apiGetShenPiBaoXiaoList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiBaoXiaoSH: function (okorno) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bxid: that.bxid,
        okorno: okorno
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(that.apiShenPiBaoXiaoSHUrl, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiBaoXiaoNum()
            that.apiGetShenPiBaoXiaoList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiChangeBaoXiaoPayStatus: function (bxid, bxpaystatus) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bxid: bxid,
        bxpaystatus: bxpaystatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ChangeBaoXiaoPayStatus, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiGetShenPiBaoXiaoNum()
            that.apiGetShenPiBaoXiaoList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(127, 124, 126);
}
</style>
